import { baseReducer } from '../../core/base-reducer';

import {
  BULK_COST_REVIEW_APPLY_RECOMMENDATIONS,
  BULK_COST_REVIEW_APPLY_RECOMMENDATIONS_ERROR,
  BULK_COST_REVIEW_APPLY_RECOMMENDATIONS_SUCCESS,
  COST_REVIEW_MODAL_CLOSE,
  BULK_COST_REVIEW_JOB_SUCCESS,
  COST_REVIEW_MODAL_OPEN,
  BULK_COST_REVIEW_JOB_STARTED,
  BULK_COST_REVIEW_JOB_ERROR,
} from './bulk.cost-review.actions';

const initialState = {
  isLoading: false,
  isApplyingRecommendations: false,
  appliedSavings: undefined,
  jobGuid: '',
  hasError: false,
};

const actionHandlerMap = {
  [COST_REVIEW_MODAL_OPEN]: (state) => {
    return {
      ...state,
      isLoading: true,
      hasError: false,
    };
  },
  [BULK_COST_REVIEW_JOB_STARTED]: (state, action) => {
    return {
      ...state,
      jobGuid: action.jobGuid,
      hasError: false,
    };
  },
  [BULK_COST_REVIEW_JOB_SUCCESS]: (state) => {
    return {
      ...state,
      isLoading: false,
    };
  },
  [BULK_COST_REVIEW_JOB_ERROR]: (state) => {
    return {
      ...state,
      isLoading: false,
      hasError: true,
    };
  },
  [COST_REVIEW_MODAL_CLOSE]: () => {
    return initialState;
  },
  [BULK_COST_REVIEW_APPLY_RECOMMENDATIONS]: (state) => {
    return {
      ...state,
      isApplyingRecommendations: true,
    };
  },
  [BULK_COST_REVIEW_APPLY_RECOMMENDATIONS_SUCCESS]: (state, action) => {
    return {
      ...state,
      isApplyingRecommendations: false,
      appliedSavings: action.amountSaved,
      isLoading: true, // want to show spinner while we wait for new rates
    };
  },
  [BULK_COST_REVIEW_APPLY_RECOMMENDATIONS_ERROR]: (state) => {
    return {
      ...state,
      isApplyingRecommendations: false,
    };
  },
};

export const bulkCostReviewReducer = baseReducer(initialState, actionHandlerMap);

export { namespace } from './bulk.cost-review.reducer.metadata';
